import { useQuery } from "@apollo/client";
import { Autocomplete, Stack, TextField } from "@mui/material";

import { GET_TENANTS } from "./api";
import { isValidCn } from "./utils";

export interface CnFormData {
  cnValue: string;
  tenantId: string | null;
  description: string;
}

interface CnFormProps {
  data: CnFormData;
  onChange: (data: CnFormData) => void;
}

export function CnForm({ data, onChange }: CnFormProps): JSX.Element {
  const { data: tenantsData, loading: loadingTenants } = useQuery(GET_TENANTS);
  const tenants = tenantsData?.tenants.items ?? [];

  const selectedTenant = tenants.find((t) => t.id === data.tenantId) ?? null;

  return (
    <Stack spacing={3} sx={{ mt: 1, minWidth: 400 }}>
      <TextField
        label="CN Value"
        value={data.cnValue}
        onChange={(e) => onChange({ ...data, cnValue: e.target.value })}
        placeholder="CN123456789"
        required
        helperText="Must start with 'CN'"
        error={data.cnValue.length > 0 && !isValidCn(data.cnValue)}
      />

      <Autocomplete
        options={tenants}
        getOptionLabel={(option) => option.name}
        loading={loadingTenants}
        value={selectedTenant}
        onChange={(_event, newValue) => {
          onChange({ ...data, tenantId: newValue?.id ?? null });
        }}
        renderInput={(params) => <TextField {...params} label="Tenant" required />}
      />

      <TextField
        label="Description"
        value={data.description}
        onChange={(e) => onChange({ ...data, description: e.target.value })}
        placeholder="STEERS Company Name (optional)"
        multiline
        rows={2}
      />
    </Stack>
  );
}
